/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Груз
 */
export type OrderDeliveryInfoCargoSeparateItem = {
  /**
   * Тип посылки
   */
  type: OrderDeliveryInfoCargoSeparateItem.type
  /**
   * Высота посылки (в см)
   */
  height: number
  /**
   * Ширина посылки (в см)
   */
  width: number
  /**
   * Длина посылки (в см)
   */
  length: number
  /**
   * Вес посылки (в г)
   */
  weight: number
  /**
   * Количество
   */
  amount: number
}
export namespace OrderDeliveryInfoCargoSeparateItem {
  /**
   * Тип посылки
   */
  export enum type {
    CUSTOM = 'custom',
    PALLET = 'pallet'
  }
}
